import React, { createContext, useContext } from 'react';

const StyleContext = createContext();

export const StyleProvider = ({ children }) => {


  const getCSSVariable = (variable) => {
    return getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
  };

  const parsePxValue = (value) => {
    return parseFloat(value.replace('px', ''));
  };

  const petButtonRadius = parsePxValue(getCSSVariable('--petbutton-radius'));
  const tooltipPadding = parsePxValue(getCSSVariable('--tooltip-padding'));
  const tooltipCornerRadius = parsePxValue(getCSSVariable('--tooltip-corner-radius'));
  const tooltipFontSize = parsePxValue(getCSSVariable('--tooltip-font-size'));
  const tooltipBackgroundColor = getCSSVariable('--tooltip-bg-color'); // Assuming this doesn't have a unit
  const tooltipTextColor = getCSSVariable('--tooltip-text-color'); // Assuming this doesn't have a unit
  const fontPrimary = getCSSVariable('--font-primary'); //font used
  const textPrimaryColor = getCSSVariable('--text-primary'); //text color

  const passwordVisibilityBackground = getCSSVariable('--password-visibility-background');
  const passwordVisibilityBackgroundHover = getCSSVariable('--password-visibility-background-hover');
  const passwordVisibilityBackgroundActive = getCSSVariable('--password-visibility-background-active');

  return (
    <StyleContext.Provider value={{ 
      petButtonRadius,
      tooltipPadding,
      tooltipCornerRadius,
      tooltipFontSize,
      tooltipBackgroundColor,
      tooltipTextColor,
      fontPrimary,
      textPrimaryColor,
      passwordVisibilityBackground,
      passwordVisibilityBackgroundHover,
      passwordVisibilityBackgroundActive
      }}>
      {children}
    </StyleContext.Provider>
  );
};

export const useStyle = () => useContext(StyleContext);
